import { render, staticRenderFns } from "./NewsCard.vue?vue&type=template&id=033cd900&scoped=true&"
import script from "./NewsCard.vue?vue&type=script&lang=js&"
export * from "./NewsCard.vue?vue&type=script&lang=js&"
import style0 from "./NewsCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewsCard.vue?vue&type=style&index=1&id=033cd900&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033cd900",
  null
  
)

export default component.exports